@if (item$ | async; as item) {
  @if (groupedTreatment) {
    <div class="treatment-card-group"></div>
  }

  <div class="treatment-card" [class.flat]="flat()">
    <div class="flex items-center">
      <div class="header-wrapper flex-1">
        <pr-charted-item-header
          [item]="item"
          [highlighted]="hasSelectedSurface$ | async"
          [compact]="compact"
          [minimal]="minimal()"
          [config]="config$ | async"
          [plan]="plan$ | async"
          (updateChartable)="updateChartable.emit($event)"
          (editSurfaces)="editSurfaces()"
        >
          <ng-container ngProjectAs=".header-info">
            <ng-content select=".header-info" />
          </ng-container>

          <ng-container ngProjectAs=".drag-handle">
            <ng-content select=".drag-handle" />
          </ng-container>

          <ng-container ngProjectAs=".checkbox">
            <ng-content select=".checkbox" />
          </ng-container>

          <ng-container ngProjectAs=".attributed-to">
            <ng-content select=".attributed-to" />
          </ng-container>

          <ng-container ngProjectAs=".header-buttons">
            <ng-content select=".deposit-indicator" />
            <ng-content select=".category-indicator" />
            <ng-content select=".change-treatment-package" />
            <ng-content select=".multi-step-buttons" />
            <ng-content select=".change-fee-schedule" />
            <ng-content select=".expand-all" />
            <ng-container ngProjectAs=".toggle-content">
              <button
                mat-icon-button
                class="icon-sm"
                aria-label="Toggle treatment"
                [matTooltip]="
                  content.expanded ? 'Hide Treatment' : 'Show Treatment'
                "
                (click)="toggleContent()"
              >
                <mat-icon>
                  {{ content.expanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>
            </ng-container>

            <ng-content select=".grouped-treatment-menu" />

            @if (!disabled && groupedTreatment === false) {
              <button
                mat-icon-button
                class="icon-sm"
                [matMenuTriggerFor]="menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-template matMenuContent>
                  <button mat-menu-item (click)="openNoteDialog(item)">
                    <mat-icon>note_add</mat-icon>
                    Add Note
                  </button>

                  <button
                    mat-menu-item
                    [disabled]="editDisabled$ | async"
                    (click)="editSurfaces()"
                  >
                    <mat-icon>select_all</mat-icon>
                    Add/Change Surfaces
                  </button>

                  <ng-content select=".menu-buttons" />

                  <button
                    *ngIf="!disabled"
                    mat-menu-item
                    (click)="itemDelete.emit(item)"
                  >
                    <mat-icon color="warn">delete</mat-icon>
                    Delete Treatment
                  </button>
                </ng-template>
              </mat-menu>
            }
          </ng-container>
        </pr-charted-item-header>
      </div>
    </div>

    <pt-collapsible #content>
      <ng-template ptCollapsibleContent>
        <mat-divider />
        <div class="content-container">
          <ng-content />
        </div>
      </ng-template>
    </pt-collapsible>
  </div>
}
